import {
  LearnerSingleAssignmentPostQuery,
  LearnerSingleAssignmentPostQueryVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";
import { MessageContentFragment } from "@outschool/ui-components-classroom";

export const singleAssignmentPostQuery = gql`
  query LearnerSingleAssignmentPost($assignmentClassPostUid: ID!) {
    assignmentClassPost(uid: $assignmentClassPostUid) {
      uid
      title
      publishAt
      user {
        uid
        name
        photo
      }
      messageContent {
        ...MessageContentFragment
      }
      submissionRequirement
      dueDate
      comments {
        uid
        sender {
          uid
          name
          photo
          avatar
          isLearner
        }
        sentAt
        messageContent {
          ...MessageContentFragment
        }
        isSubmission
        replies {
          uid
          sender {
            uid
            name
            photo
            avatar
            isLearner
          }
          sentAt
          messageContent {
            ...MessageContentFragment
          }
          isSubmission
        }
      }
    }
  }
  ${MessageContentFragment}
`;

export const useSingleAssignmentPostQuery = ({
  assignmentClassPostUid,
  skip = false,
}: {
  assignmentClassPostUid: string;
  skip?: boolean;
}) =>
  useQueryWithPreviousData<
    LearnerSingleAssignmentPostQuery,
    LearnerSingleAssignmentPostQueryVariables
  >(singleAssignmentPostQuery, {
    variables: { assignmentClassPostUid },
    fetchPolicy: "cache-and-network",
    skip: skip || !assignmentClassPostUid,
  });
